
import React, { useState, useEffect, Fragment, useRef } from 'react'
import {
  Select, Form, Input, Button, Modal, Checkbox,
  Upload, Row, Col, DatePicker, message, InputNumber, Space, Radio, TreeSelect, Tree, Divider
} from "antd";
const { RangePicker } = DatePicker;
const { TextArea } = Input
import { MinusCircleOutlined, } from '@ant-design/icons';
import RoleApi from '@api/role'
import sysApi from '@api/sys'
import ResourceApi from '@api/resource'
import AddModal from '@components/Modal'
import { identifierData } from '@utils/common'
import moment, { weekdays } from 'moment';
import { alarmApi, stationApi, dictApi } from "@api/newApi";
import InspectionApi from '@api/inspectionnew'
import { treeConversion, treeIds, extraIds } from '@utils/common'
import ChooseCycle from '@components/ChooseCycle'

import '../style.scss'
import './upkeepTemplate.scss'

const layout = {
  labelCol: { span: 6 },
  wrapperCol: { span: 17 },
};
const { SHOW_PARENT, SHOW_ALL, TreeNode } = TreeSelect;
const Option = Select.Option


export default ({ title, visible, formData = null, cancel, stationData }) => {
  const [form] = Form.useForm();
  const [editBool, setEditBool] = useState(false)
  const [resourceTree, setResourceTree] = useState()
  const [formValue, setFormValue] = useState(formData)
  const [loading, setLoading] = useState()
  // 所有的树形id
  const [allIds, setAllIds] = useState([])
  const [isManager, setIsManger] = useState(0)
  // 处理人列表
  const [personItems, setPersonItems] = useState([])
  const [deviceArry, setDeviceArry] = useState([])
  const [patrolItems, setPatrolItems] = useState()
  const [defectLevelIdArr, setDefectLevelIdArr] = useState([])
  const [sourceIdArr, setSourceIdArr] = useState([])
  const [users, setUsers] = useState([])
  const [units,setUnits] = useState([])
  // 角色列表
  const [roleLs, setRoleLs] = useState()

  // 厂站集合
  const [patrolItemParams, setPatrolItemParams] = useState({
    stationId: '',
    type: '',
    materielId: '',
    processunitClassifyId: '',
    processunitId: '',
    deviceClassifyId: '',
  })

  useEffect(() => {
    // 查询角色列表
    RoleApi.query({ pageNum: 1, pageSize: 10000 }).then(res => {
      if (res.status !== '0') return
      setRoleLs(res.data.data)
    })
    InspectionApi.taskQuery({ pageSize: 100, pageNum: 1 }).then(res => {
      setLoading(false)
      if (res.status == 0 && res.data) {
        setSourceIdArr(res.data.data)
      }
    })
  }, [visible])

  // 切换厂站，查询巡检项
  const changeStation = (val) => {
    getDatas()
  }
  // 获取模版列表, 获取人员列表
  const getDatas = (id = null) => {
    let stationIds = form.getFieldValue('stationId') ? form.getFieldValue('stationId') : id;
    if (stationIds) {
      RoleApi.userByStand({ stationId: stationIds }).then(res => {
        let user = []
        Object.keys(res.data).map(key => {
          res.data[key].map(item => {
            user.push(item)
          })
        })
        setUsers(user)
      })
    }
  }
  const getChild = (arr) => {
    const role = form.getFieldValue('handleRole')
    return arr.map(item => {
      if (item.children && item.children.length > 0) {
        item.children = getChild(item.children);
        if (role != 'area_manager') {
          item.disabled = item.deviceId ? false : true;
        }
        return item;
      } else {
        delete item.children;
        if (role != 'area_manager') {
          item.disabled = item.deviceId ? false : true;
        }
        return item;
      }

    })
  }
  const addItem = () => {
    const list = form.getFieldValue('upkeepTemplateItemDTOList')
    list.push({
      unit: '个周', 
      grease:'',
      itemContent:'',
      oilMass:'',
      period: '1'
    })
    form.setFieldsValue({upkeepTemplateItemDTOList: list})
    setFormValue({upkeepTemplateItemDTOList: list})
  }
  const removeItem = (index) => {
    let list = form.getFieldValue('upkeepTemplateItemDTOList')
    list.splice(index, 1)
    form.setFieldsValue({upkeepTemplateItemDTOList: list})
    setFormValue({upkeepTemplateItemDTOList: list})
  }
  // 提交
  const submit = () => {
    form.validateFields().then( async values => {
      if (!values) {
        return;
      }
      let flag = false
      const jsonValues = JSON.parse(JSON.stringify(values))
      jsonValues.upkeepTemplateItemDTOList.map(item => {
        // if ( !item.grease && !item.oilMass ) {
        //   message.error('油脂和油量必须选择一个')
        //   flag = true
        // }
        item.period = item.period + item.unit
      })
      if ( flag ) return
      setLoading(true)
      let params = {
        ...jsonValues
      }
      if (formData && formData.id) {
        // 获取流程id
        const result = await sysApi.getFlowableId({dictType: 'sw-flowable',dictKey: 'upkeep_template_updateInfo' })
        if (result.status !== '0') return
        const processId = result.data
        InspectionApi.upkeepTemplateUpdateInfo({...params,id:formData.id},processId).then(res => {
          if ( res.status !== '0' ) return
          message.success('编辑成功')
          handelCancel(true)
          setLoading(false)
        })

      } else {
        InspectionApi.upkeepTemplateAdd(params).then( async res => {
          if (res.status == 0) {
            const result = await sysApi.getFlowableId({dictType: 'sw-flowable',dictKey: 'upkeep_template_status_enable' })
            if (result.status !== '0') return
            const processId = result.data            
            const values = await InspectionApi.upkeepTemplateEnable({id: res.data, processId})
            if (values.status !== '0') return
            message.success('新增成功')
            handelCancel(true)
          }
          setLoading(false)
        }).catch((err) => {
          setLoading(false)
        })
      }
    })
  }
  // 取消
  const handelCancel = (bool = false) => {
    form.resetFields();
    cancel(bool);
  }
  return (
    <AddModal title={title} footer={[
      <Row key={'btn'} span={24}>
        <Button key={1} onClick={handelCancel} className='abuttons'>
          <i className='iconfont iconfanhui'>
          </i>&nbsp;&nbsp;取消
        </Button>
        <Button key={2} loading={loading} onClick={submit} className='abuttons' type="primary">
          <i className='iconfont iconbaocun'>
          </i>&nbsp;&nbsp;保存
        </Button>
      </Row>]
    } visible={visible} width={1200} okText={'确定'} onCancel={handelCancel} onSubmit={() => submit()}>
      <div className='userModal'>
        <Form preserve={false}
          {...layout}
          layout="horizontal"
          form={form}
          style={{ marginTop: '20px' }}
          labelAlign="right"
          labelCol={{span: 3}}
          initialValues={formValue}
        >
          <Form.Item
            label='名称'
            name="templateName"
            rules={[{ required: true, message: '请输入模板名称' }]}
          >
            <Input row={4} placeholder={'请输入保养名称'} />
          </Form.Item>
          <Form.Item label="模板类型" name="templateType" rules={[{ required: true, message: '请选择模板类型' }]}>
            <Select
			  disabled
              placeholder="模板类型"
            >
              <Option value={0}>设备人员模板</Option>
              <Option value={1}>操作人员模板</Option>
            </Select>
          </Form.Item>
          <Form.Item label='保养项'>
            <Form.List name="upkeepTemplateItemDTOList">
              {(fields, { add, remove }) => {
                return <>
                  {fields.map((field, index) => (
                    <Row key={field.key}>
                      <Col span={24}>
                        <Space className='add-content-item'>
                          <Form.Item name={[field.name, 'itemContent']} label="保养内容" rules={[{ required: true, message: '请输入保养内容' }]}>
                            <TextArea rows={2} placeholder='请输入保养内容' />
                          </Form.Item>
                          <Form.Item name={[field.name, 'grease']} label="油脂" rules={[{ required: true, message: '请输入油脂' }]}>
                            <Input placeholder='请输入油脂' />
                          </Form.Item>
                          <Form.Item name={[field.name, 'oilMass']} label="油量" rules={[{ required: true, message: '请输入油量' }]}>
                            <Input placeholder='请输入油量' />
                          </Form.Item>
                          <div className='period'>
                            <Form.Item name={[field.name, 'period']} label="周期" rules={[{ required: true, message: '请输入周期' }]}>
                              <InputNumber className='period-ipt' min={1} max={12} />
                            </Form.Item>
                            <Form.Item name={[field.name, 'unit']} className="period-unis">
                              <Select>
                                <Option value="个周">个周</Option>
                                <Option value="个月">个月</Option>
                              </Select>
                            </Form.Item>
                          </div>
                        </Space>
                      </Col>
                      <Col span={.5}>
                        {fields.length > 1 && <MinusCircleOutlined onClick={() => { removeItem(index) }} style={{ marginLeft: '15px', margin: '10px,0' }} />}
                      </Col>
                      {fields.length > 1 && <Divider dashed style={{ marginTop: '0px' }}></Divider>}
                    </Row>
                  ))}
                  <Form.Item>
                    <Button type="dashed" onClick={ () => addItem() }>
                      添加
                    </Button>
                  </Form.Item>
                </>
              }}
            </Form.List>
          </Form.Item>
        </Form>
      </div>
    </AddModal>
  )

}
